export default __webpack_public_path__ + "static/media/question.f61bf2e4.png";